import { CoverageCheckbox as CoverageCheckboxSchema } from '@/schemas/sceneDataSchema';
import { Checkbox } from '@mui/material';
import { useCoverageAttribute } from '@/hooks/use-quote';
import { useCallback } from 'react';

export default function CoverageCheckboxFormElement({ component }: { component: CoverageCheckboxSchema }) {
  const { findSelectedIndex, handleSelectByIndex } = useCoverageAttribute({
    symbol: component.symbol,
    scope: component.scope,
    kind: component.kind,
  });

  const selectedIndex = findSelectedIndex();
  // TODO revisit this - First option = checked, anything else = unchecked
  const isChecked = selectedIndex === 0;

  const handleChange = useCallback(
    (checked: boolean) => {
      handleSelectByIndex(checked ? 0 : 1);
    },
    [handleSelectByIndex]
  );

  return (
    <Checkbox
      id={`${component.symbol}-${component.scope}-${component.kind}`}
      name={`${component.symbol}-${component.scope}-${component.kind}`}
      onChange={(e) => handleChange(e.target.checked)}
      checked={isChecked}
    />
  );
}
